const userTypes = {
    EMAIL_SIGN_IN_START: 'EMAIL_SIGN_IN_START',
    SIGN_IN_SUCCESS: 'SIGN_IN_SUCCESS',
    CHECK_USER_SESSION: 'CHECK_USER_SESSION',
    SIGN_OUT_USER_START: 'SIGN_OUT_USER_START',
    SIGN_OUT_USER_SUCCESS:'SIGN_OUT_USER_SUCCESS',
    LOADING: 'LOADING',
    SET_LOADING: 'SET_LOADING'
};

export default userTypes;